<template>
  <v-card color="transparent" elevation="0" width="auto">
    <v-row class="pt-5">
      <v-col :cols="isMobile ? 12 : 12">
        <CardAtualizacoesCliente :dados="dados" />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
  import CardAtualizacoesCliente from '@/components/JornadaDaCota/CardAtualizacoesCliente.vue'

  export default {
    name: 'CardTopoAtualizacoes',
    components: {
      CardAtualizacoesCliente
    },
    props: {
      dados: Object
    },
    data: () => ({
      loadingSkeleton: false
    }),
    computed: {
      isMobile () {
        return this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs
      }
    },
    mounted () {
      // console.info('DADOS-1', this.dados.extratoCota)
    }
  }
</script>
